/**
 * TanStack Router: /my-team
 *
 * This route file was auto-generated by the route generation script.
 * Component: MyTeamPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MyTeamPage from '@/app/my-team'

/**
 * Route: /my-team
 * Layout: _auth (authenticated)
 * Component: MyTeamPage
 */
export const Route = createFileRoute('/_auth/my-team')({
  component: MyTeamPage,
})
